module.exports = __webpack_public_path__ + "static/media/avillion.dfb8ee04.PNG";